<template>
  <div>
    <CrudList
      title="Time Ranges"
      storeName="Time_range"
      labelAddNew="Agregar nuevo Time Range"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      canSearch
    >
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
  };
</script>
